import catImage from './Images/cat.svg';
import dogImage from './Images/dog.svg';
import puppyImage from './Images/puppy.svg';
import bulldogImage from './Images/bulldog.svg';
import rodentImage from './Images/rodent.svg';
import birdImage from './Images/bird.svg';
import reptileImage from './Images/reptile.svg';
import fishImage from './Images/fish.svg';
import horseImage from './Images/horse.svg';
import downImage from './Images/down.svg';
import femaleImage from './Images/female.svg';
import logo from './Images/logo.svg';
import maleImage from './Images/male.svg';
import pawprintImage from './Images/pawprint.svg';
import upImage from './Images/up.svg';
import userImage from './Images/user.svg';
import infoImage from './Images/info.svg';
import errorImage from './Images/error.svg';
import successImage from './Images/success.svg';
import amphibiansImage from './Images/amphibians.svg';

const Storage = new Map([
  ['cat', catImage],
  ['dogSmall', dogImage],
  ['dogBig', dogImage],
  ['dog', dogImage],
  ['puppy', puppyImage],
  ['bulldog', bulldogImage],
  ['rodent', rodentImage],
  ['bird', birdImage],
  ['reptile', reptileImage],
  ['fish', fishImage],
  ['horse', horseImage],
  ['down', downImage],
  ['female', femaleImage],
  ['logo', logo],
  ['male', maleImage],
  ['pawprint', pawprintImage],
  ['up', upImage],
  ['user', userImage],
  ['info', infoImage],
  ['error', errorImage],
  ['success', successImage],
  ['amphibians', amphibiansImage],
  ['ponny', horseImage]
]);

export default Storage;



// WEBPACK FOOTER //
// ./src/pages/Helpers/Storage/Storage.js